import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  root: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 32,
    '&:nth-of-type(2) .content': {
      padding: '1.25rem 2.5rem',
      backgroundColor: palette.info.light,
    },
    '&:nth-of-type(2) > span': {
      marginBottom: 0,
    },
  },
}));
